interface RenderAvatarSvgProps {
  shape: string;
  color1: string;
  color2: string;
  size?: number;
}

const RenderAvatarSvg = ({ shape, color1, color2, size = 60 }: RenderAvatarSvgProps) => {
  return (
    <svg className="render-avatar-svg" width={size} height={size}>
      {shape === "square" && <rect width={size} height={size} fill={color1} />}
      {shape === "circle" && (
        <circle cx={size / 2} cy={size / 2} r={size / 2} fill={color1} />
      )}
      {shape === "halfTriangle" && (
        <>
          <polygon points={`0,0 ${size},0 0,${size}`} fill={color1} />
          <polygon
            points={`${size},${size} ${size},0 0,${size}`}
            fill={color2}
          />
        </>
      )}
    </svg>
  );
};

export default RenderAvatarSvg;
